import { IFileDocument } from '../file-document';

export enum AnnouncementStatus {
    active = 'active',
    expired = 'expired',
    future = 'future',
}

export interface IAnnouncement {
    id?: string;
    corporationNumberId: number;
    corporationNumberName: string;
    title: string;
    text: string;
    document: IFileDocument;
    periodBegin: string | Date;
    periodEnd: string | Date;
    createdAt?: string;
    createdBy?: {
        fullName: string
        id: number
        email: string
    };
    resendToSubscribers?: boolean;
    status?: AnnouncementStatus;
}

export class Announcement implements IAnnouncement {
    id: string;
    corporationNumberId: number;
    corporationNumberName: string;
    periodBegin: string | Date;
    periodEnd: string | Date;
    text: string = '';
    document: IFileDocument = null;
    title: string = '';
    resendToSubscribers: boolean = false;

    constructor(corporationNumberId: number = null, title: string = '', text: string = '', periodBegin: string | Date = new Date(), periodEnd: string | Date = null) {
        this.corporationNumberId = corporationNumberId;
        this.periodBegin = periodBegin;
        this.periodEnd = periodEnd;
        this.text = text;
        this.title = title;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/announcement.ts